import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimationCarouselPanelComponent } from './animation-carousel-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AnimationCarouselCardModule } from './components/animation-carousel-card/animation-carousel-card.module';

@NgModule({
  declarations: [AnimationCarouselPanelComponent],
  exports: [AnimationCarouselPanelComponent],
  imports: [
    CommonModule,
    SharedModule,
    AnimationCarouselCardModule
  ],
})
export class AnimationCarouselPanelModule { }
